
import Breadcrumbs from "~/components/UI/Breadcrumbs";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";

export default {
  name: "index",

  head: function () {
    const title = this.seoTitle;
    const description = this.seoDescription;

    return {
      title: title,
      titleTemplate: "",
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: title},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
    }
  },
  asyncData: async function (ctx) {
    const { $api, route, error } = ctx;
    const slug = route?.params?.cityfrom || "";
    const infoCity = await $api.agent.transport.get(`/route/from?slug_from=${ slug }`).then((res) => {
      return res.data
    }).catch(() => {
      return null
    });
    if (!infoCity || infoCity.length <= 0) {
      error({
        statusCode: 404
      });
      return
    }

    return {
      infoCity: infoCity
    }
  },

  computed: {
    breadcrumbs: function () {
      const cityFrom = (this.infoCity?.[0]?.city_from_case || this.infoCity?.[0]?.city_from || "");
      return [
        { title: "Главная", path: "/" },
        { title: "Грузоперевозки по России", path: "/routes" },
        { title: `из ${cityFrom}`, path: this.$route.path },
      ]
    },

    h1: function () {
      const info = this.infoCity?.[0]?.city_from_case || "";
      return `Грузоперевозки из ${ info } по России`
    },
    seoTitle: function () {
      const info = this.infoCity?.[0]?.city_from_case || "";
      return `Цены на грузоперевозки из ${info} по России - транспортная компания Централ Транс`
    },
    seoDescription: function () {
      const info = this.infoCity?.[0]?.city_from_case || "";
      return `Грузоперевозки из ${info} по России выделенным транспортом от 1 до 20 тонн и низкорамными тралами. Гарантируем безопасную перевозки ваших грузов и низкие цены.`
    },
    defaultSubdomain: function () {
      return this.$store.state?.appState?.vars?.['Дефолтный SLUG города'] || ""
    },

    tableRows: function () {
      const info = this.infoCity?.[0]?.city_from || "";
      return (this.infoCity || []).map((city) => {
        return [
          [info, city.city_to].filter((t) => !!t).join(" - "),
          this.multipleFactor(city.price_1_5, 1),
          this.multipleFactor(city.price_3, 1),
          this.multipleFactor(city.price_5, 1),
          this.multipleFactor(city.price_10, 1),
          this.multipleFactor(city.price_20, 1),
        ]
      })
    },
    annotation: function () {
      return this.$store.state?.appState?.vars?.['Публичная оферта страниц маршрутов']
    }
  },

  components: {
    Breadcrumbs,
    TableCityPrices: () => import("~/components/routes/TableCityPrices"),
    MobileTableCityPrices: () => import("~/components/routes/MobileTableCityPrices.vue"),
  },

  methods: {
    multipleFactor: function (value, factor) {
      const number = value + (value * Number.parseFloat(process.env.FREIGHT_PRICE_MULTIPLE || '0.1')) * factor;
      return `${this.$numberFormat(number)} руб.`
    },

    clickRows: function (cityName) {
      cityName = (cityName?.[0] || '').split(' - ').pop();
      const city = (this.infoCity || []).find((t) => t.city_to === cityName);
      const slug = `/routes/${city?.cities?.from?.sub_domain || this.defaultSubdomain}/${city?.cities?.to?.sub_domain || this.defaultSubdomain}`;
      this.$router.push(slug);
    },
    openFormSubmitApplication: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          title: "Оставить заявку",
          activeTab: "big",
          hideTabs: true,
          type: 'Оставить заявку'
        }
      });
    },
  }
}
